import { render, staticRenderFns } from "./score-card-list.vue?vue&type=template&id=46f888df"
import script from "./score-card-list.vue?vue&type=script&lang=js"
export * from "./score-card-list.vue?vue&type=script&lang=js"
import style0 from "./score-card-list.vue?vue&type=style&index=0&id=46f888df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports